import React from 'react';
import ExpandableDescription from './ExpandableDescription';
import './PartnersPanel.css';

const PartnersPanel = ({ partners, partnersLoading, filteredPartners, searchQuery, proofT }) => {
  return (
    <div className="tab-panel active">
      {partnersLoading ? (
        <div className="loading-message">{proofT('partners.loading')}</div>
      ) : filteredPartners.length === 0 ? (
        <div className="no-results">{proofT('partners.noResults', 'No partners found')}</div>
      ) : (
        <>
          {/* Results count */}
          <div className="results-info">
            <p className="results-text">
              {filteredPartners.length === 1 
                ? proofT('partners.showing', 'Showing {count} partner').replace('{count}', filteredPartners.length)
                : proofT('partners.showingPlural', 'Showing {count} partners').replace('{count}', filteredPartners.length)}
              {searchQuery && proofT('partners.forQuery', ' for "{query}"').replace('{query}', searchQuery)}
            </p>
          </div>
          
          <div className="partners-grid">
            {filteredPartners.map((partner) => (
              <div key={partner.id} className="case-study" data-category={partner.category || ''}>
                <div className="case-study-header">
                  <div className="case-study-logo">
                    <img 
                      src={`/icons/partners/${(partner.name || '').toLowerCase()}.png`} 
                      alt={`${partner.name || ''} ${proofT('partners.logoAlt')}`} 
                      className="case-study-logo-img"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        // Create a fallback div with company initials
                        const fallback = document.createElement('div');
                        fallback.className = 'case-study-logo-fallback';
                        fallback.textContent = ((partner.name || '??').substring(0, 2)).toUpperCase();
                        e.target.parentNode.appendChild(fallback);
                      }}
                    />
                  </div>
                  <div className="company-info">
                    <div className="company-name">{partner.name || ''}</div>
                    <div className="company-industry">{partner.category || ''}</div>
                  </div>
                  {partner.status && <div className="impact-badge partner-status-badge">{(partner.status || '').toUpperCase()}</div>}
                </div>
                <ExpandableDescription 
                  description={partner.description || ''} 
                  partnerId={partner.id}
                  proofT={proofT}
                />
                <div className="case-study-footer">
                  <div className="partner-certification">
                    <span className="cert-label">{proofT('partners.certification')}</span>
                    <span className="cert-level">{partner.certificationLevel || ''}</span>
                  </div>
                  <div className="website-options">
                    {partner.website ? (
                      <a 
                        href={partner.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="website-btn"
                        title={proofT('partners.visitWebsiteTitle', 'Visit {name} website').replace('{name}', partner.name || '')}
                      >
                        {proofT('partners.visitWebsite')}
                      </a>
                    ) : (
                      <button 
                        className="website-btn"
                        onClick={() => {
                          const baseUrl = '/docs/resources/partners';
                          const translationPath = partner.translations && partner.translations['en'] 
                            ? partner.translations['en'] 
                            : partner.htmlFile;
                          const downloadUrl = `${baseUrl}/${translationPath}`;
                          window.open(downloadUrl, '_blank');
                        }}
                      >
                        {proofT('partners.viewProfile')}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default PartnersPanel;

